import { List, ListItem, Paper, Typography } from "@mui/material";
import { ResultInfo } from "@/ImageRepo";
import React from "react";

const ShepGridWarning = ({
  title = "No Data Available.",
  message,
  options = null,
  ...props
}) => {
  return (
    <Paper
      elevation={0}
      style={{ padding: "35px", borderRadius: "12px" }}
      {...props}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <ResultInfo width="20" height="20" />
        <Typography variant="contentAccent1" style={{ paddingLeft: "15px" }}>
          {title}
        </Typography>
      </div>

      {message && (
        <Typography style={{ paddingLeft: "35px" }}>{message}</Typography>
      )}
      {options && (
        <List
          sx={{
            listStyleType: "disc",
            listStylePosition: "inside",
            marginTop: "10px",
            marginLeft: "35px",
          }}
        >
          {options.map((option, index) => {
            return (
              <ListItem key={index} sx={{ display: "list-item" }}>
                {option}
              </ListItem>
            );
          })}
        </List>
      )}
    </Paper>
  );
};

export default ShepGridWarning;
